import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import FilterSet from 'components/Explorer/models/filter_set';
import useFilterLookup from 'hooks/useFilterLookup';

import AutocompleteField from '../../AutocompleteField';
import HelpLink from '../HelpLink';

const ANALYTICS_FIELD_NAME = 'Field Of Research';

const FieldOfResearchFilter = ({ filterSet, initialSearch }) => {
  const filterCodes = filterSet.get('field_of_research_codes[]').map((code) => ({ id: code }));
  const fieldRef = useRef(null);

  const { data, loading } = useFilterLookup('filters/fields_of_research', { enabled: filterCodes.length > 0 });
  const codes = data ?? [];

  useEffect(() => {
    if (!fieldRef.current) return;
    if (!filterCodes.length) fieldRef.current.clearAll();
  }, [filterCodes.length]);

  const updateSelectedCodes = (selected) => {
    filterSet.set(
      'field_of_research_codes[]',
      selected.map((code) => code.id)
    );
  };

  const unknownCodes = filterCodes.length > codes.length;

  return (
    <div className="Explorer-AdvancedSearch-field FieldOfResearchFilter">
      <label>
        {I18n.t('Explorer.AdvancedSearch.fields.field_of_research.name')}
        <HelpLink
          href={I18n.t('Explorer.AdvancedSearch.help_uri')}
          tip={I18n.t('Explorer.AdvancedSearch.fields.field_of_research.help')}
          analyticsFieldName={ANALYTICS_FIELD_NAME}
        />
      </label>
      {loading ? (
        <div>{I18n.t('Explorer.AdvancedSearch.fields.field_of_research.loading')}</div>
      ) : (
        <AutocompleteField
          name="field_of_research"
          id="field_of_research"
          type="field_of_research_codes"
          initialValue={initialSearch}
          placeholder={I18n.t('Explorer.AdvancedSearch.fields.field_of_research.placeholder')}
          onChangeItems={updateSelectedCodes}
          initiallySelected={codes}
          ref={fieldRef}
          analyticsEventPrefix="Advanced Search: Field"
          analyticsFieldName={ANALYTICS_FIELD_NAME}
        />
      )}
      {unknownCodes && !loading && (
        <div className="unknown-for-warning">
          <h6>{I18n.t('Explorer.AdvancedSearch.fields.field_of_research.unknown_for_warning.title')}</h6>
          <p>{I18n.t('Explorer.AdvancedSearch.fields.field_of_research.unknown_for_warning.description')}</p>
          <a href="https://help.altmetric.com/en/articles/9804289" target="_blank" rel="noreferrer">
            {I18n.t('Explorer.AdvancedSearch.fields.field_of_research.unknown_for_warning.link_text')}
          </a>
        </div>
      )}
    </div>
  );
};

FieldOfResearchFilter.propTypes = {
  filterSet: PropTypes.instanceOf(FilterSet).isRequired,
  initialSearch: PropTypes.string
};

export default FieldOfResearchFilter;
